import type { AutoStashUpdateState } from 'stash/reducers/application/autoStashUpdate';

export const UPDATE_AUTO_STASH_FLOW = 'UPDATE_AUTO_STASH_FLOW';
export const RESET_AUTO_STASH_FLOW = 'RESET_AUTO_STASH_FLOW';

export type UpdateAutoStashFlowAction = {
	type: typeof UPDATE_AUTO_STASH_FLOW;
	payload: Partial<AutoStashUpdateState>;
};

export type ResetAutoStashFlowAction = {
	type: typeof RESET_AUTO_STASH_FLOW;
};

export type AutoStashUpdateAction =
	| UpdateAutoStashFlowAction
	| ResetAutoStashFlowAction;

/**
 * Shallow-merges the provided fields into `application.autoStashUpdate`.
 *
 * Designed as a single, generic action so the slice can grow with the
 * Auto Stash update flow (selected amount, frequency, funding source,
 * questions-flow visit tracking, etc.) without adding a new action type
 * per field.
 */
export const updateAutoStashFlow = (
	payload: Partial<AutoStashUpdateState>,
): UpdateAutoStashFlowAction => ({
	type: UPDATE_AUTO_STASH_FLOW,
	payload,
});

/** Resets the Auto Stash update flow slice back to its initial state. */
export const resetAutoStashFlow = (): ResetAutoStashFlowAction => ({
	type: RESET_AUTO_STASH_FLOW,
});
